import React from 'react';

/**
 * Wraps a form so every field, button, click and keyboard focus inside it is ignored while it
 * is locked. `disabled` only covers form controls, so `inert` also covers focusable elements
 * such as the document dropzone; pointer-events is a fallback for browsers without `inert`.
 *
 * @param {Object} props
 * @param {boolean} props.isLocked Whether the content must ignore any user interaction.
 * @param {React.ReactNode} props.children Content to lock.
 * @returns {JSX.Element}
 */
const LockableFieldset = ({ isLocked, children }) => (
  <fieldset
    disabled={isLocked}
    inert={isLocked ? '' : undefined}
    style={isLocked ? { pointerEvents: 'none' } : undefined}
  >
    {children}
  </fieldset>
);

export default LockableFieldset;
